import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Popup, { Props as PopupProps } from '../../Popup';
import Logo from '@wix/da-ds/pkg/Logo';
import UserLink from '../../User/Link';
import withPopupArt, { WithPopupArtProps } from '../withPopupArt';
import s from './ArtBrandedMobilePopup.scss';

export interface Props {
  onClose?: () => void;
  popupProps?: PopupProps;
  children?: React.ReactNode | undefined;
}

const ArtBrandedMobilePopup: React.FC<Props & WithPopupArtProps> = ({
  artImageSrc,
  artAuthor,
  onClose,
  popupProps = {},
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Popup className={s['modal']} onRequestClose={onClose} {...popupProps}>
      <div className={s['root']} style={{ backgroundImage: artImageSrc && `url(${artImageSrc})` }}>
        <div className={s['inner']}>
          <Logo size="tiny" markColor="white" textColor="white" />
          <div className={s['content']}>{children}</div>
          <div className={classnames(s['artist-credit'], artAuthor && s['loaded'])}>
            {artAuthor && (
              <>
                {t('verification.artistCredit')}{' '}
                <UserLink className={s['user-link']} user={artAuthor} />
              </>
            )}
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default withPopupArt(ArtBrandedMobilePopup);
